import { useEffect, useState } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { getPagedClaims } from '../../redux/actions/claimsAction'
import { ClaimResponseType, UserType } from '../../redux/actions/types'
import styles from './StatsPage.module.css'
import iconFiltersMobile from '../../assets/icons/iconFiltersMobile.svg'
import DropDown from '../../components/DropDown/DropDown'
import { Calendar } from '../../components/CustomCalendar/components'
import { format } from 'date-fns'
import { getPlaces, getPlacesFromCompany } from '../../redux/actions/placesAction'
import CalendarIcon from '../../assets/icons/calendar.svg'
import {
  getEstablishmentFromCompany,
  getEstablishments,
} from '../../redux/actions/establishmentsAction'
import { getCurrentCompany } from '../../redux/actions/companiesAction'
import { findTotal } from '../../utils/statsCalculators'
import { getClients } from '../../redux/actions/clientsAction'
import Diagramma from '../../components/Diagramma/Diagramma'
import StatsPageTableComponent from '../../components/StatsPageTableComponent/StatsPageTableComponent'
import DownloadSmet from '../../components/DownloadSmet/DownloadSmet'
import Select from 'react-select'
import { getMe } from '../../redux/actions/meAction'
import { motion, AnimatePresence } from 'framer-motion'
import { getStaff } from '../../redux/actions/staffAction'
import { useMediaQuery } from 'react-responsive'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import FilterModalModalReports from '../../components/FilterModalReports/FilterModalReports'
import CustomModal from '../../components/UI/CustomModal/CustomModal'

const StatsPage = () => {
  const initialStartDate = new Date()
  initialStartDate.setFullYear(initialStartDate.getFullYear() - 1)

  const initialFinishDate = new Date()
  initialFinishDate.setMonth(initialFinishDate.getMonth() + 2)

  const dispatch = useAppDispatch()
  const { token, userRole, user } = useAppSelector((state) => state.auth)
  const { pagedClaims } = useAppSelector((state) => state.claims)
  const { clients } = useAppSelector((state) => state.clients)
  const { staff } = useAppSelector((state) => state.staff)
  const { places, placesFromCurrentCompany } = useAppSelector((state) => state.places)

  const { establishment } = useAppSelector((state) => state.establishments)
  const today = new Date()
  const finishDate = new Date()
  finishDate.setDate(today.getDate() + 10)
  const [openStartDate, setOpenStartDate] = useState(false)
  const [selectedStartDate, setSelectedStartDate] = useState(initialStartDate)
  const [startDateString, setStartDateString] = useState(format(initialStartDate, 'dd.MM.yyyy'))
  const [finishDateString, setFinishDateString] = useState(format(initialFinishDate, 'dd.MM.yyyy'))
  const [openFinishDate, setOpenFinishDate] = useState(false)
  const [openReportsFilter, setOpenReportsFilters] = useState(false)
  const [selectedFinishDate, setSelectedFinishDate] = useState(initialFinishDate)

  const convertToISO = (dateStr: string) => {
    if (!dateStr) return null
    const parts = dateStr.split('.')
    if (parts.length === 3) {
      const [day, month, year] = parts
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
    return dateStr
  }
  const [rangeStartISO, setRangeStartISO] = useState(
    convertToISO(format(initialStartDate, 'dd.MM.yyyy')),
  )
  const [rangeEndISO, setRangeEndISO] = useState(
    convertToISO(format(initialFinishDate, 'dd.MM.yyyy')),
  )
  const [totalPaid, setTotalPaid] = useState<number>(0)
  const [totalPrices, setTotalPrices] = useState<number>(0)
  const [willBePaid, setWillBePaid] = useState<number>(0)
  const [peopleCount, setPeopleCount] = useState<number>(0)
  const [inProgressRequests, setInProgressRequests] = useState<number>(0)
  const [rejectedRequests, setRejectedRequests] = useState<number>(0)
  const [canceledRequests, setcanceledRequests] = useState<number>(0)
  const [accepted, setAccepted] = useState<number>(0)
  const [confirmed, setconfirmed] = useState<number>(0)
  const [inAnticipation, setInAnticipation] = useState<number>(0)
  const [data, setData] = useState<ClaimResponseType[]>([])
  const [show, setShow] = useState<number>(0)
  const [paidClaims, setPaidClaims] = useState<number>(0)
  const [unpaid, setUnpaid] = useState<number>(0)
  const [companyManagers, setCompanyManagers] = useState<UserType[] | string[]>([])
  const [selectedCreator, setSelectedCreater] = useState<string>('')
  const [selectedEstablishment, setSelectedEstablishment] = useState<string>('')
  const [filteredClaims, setFilteredClaims] = useState<ClaimResponseType[]>([])
  const [creatorOptions, setCreatorOptions] = useState<{ value: string; label: string }[]>([])
  const [placeOptions, setPlaceOptions] = useState<{ value: string; label: string }[]>([])
  const [selectedPlace, setSelectedPlace] = useState<string>('')
  const [selectedClient, setSelectedClient] = useState<string>('')
  const [filteredPlaceOptions, setFilteredPlaceOptions] = useState<
    { value: string; label: string }[]
  >([])
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const selectedEstablismentForSmet = establishment?.establishments.find(
    (item) => item.id === Number(selectedEstablishment),
  )

  useEffect(() => {
    if (totalPaid !== null && totalPrices !== null) {
      setWillBePaid(totalPrices - totalPaid)
    }
  }, [totalPaid, totalPrices])
  useEffect(() => {
    if (staff.employees && staff.employees.length > 0) {
      setCompanyManagers(staff.employees.map((emp) => emp.user))
    }
  }, [staff.employees])

  useEffect(() => {
    if (companyManagers && companyManagers.length > 0) {
      const options = [
        { value: '', label: 'Все' },
        ...(companyManagers as UserType[]).map((manager) => ({
          value: String(manager?.id),
          label: manager?.fullName,
        })),
      ]
      setCreatorOptions(options)
    }
  }, [companyManagers, filteredClaims, pagedClaims, data])

  function collectPaidValues(data: any[]) {
    return data.map((item: any) => {
      if (item.paid > 0) {
        return item.paid
      }
      if (item.paymentStatus === 'Частично оплачено' && item.prepaymentAmount > 0) {
        return item.prepaymentAmount
      }
      return 0
    })
  }
  function collectPriceValues(data: any) {
    return data.map((item: any) => item.price)
  }
  function extractPeopleCounts(data: any[]): number[] {
    return data.map((item) => item.peopleCount)
  }

  const establishmentOptions = [
    { value: 'Все', label: 'Все' },
    ...establishment.establishments.map((e) => ({
      value: e?.id,
      label: e?.name,
    })),
  ]

  const clientsOptions = [
    { value: 'Все', label: 'Все' },
    ...clients.map((e) => ({
      value: e?.id,
      label: e?.fullName || e?.organizationName,
    })),
  ]

  useEffect(() => {
    if (userRole == 'superAdmin') {
      const options = [
        { value: 'Все', label: 'Все' },
        ...places.places.map((e) => ({
          value: String(e?.id),
          label: e?.name,
        })),
      ]
      setPlaceOptions(options)
    } else {
      const options = [
        { value: 'Все', label: 'Все' },
        ...placesFromCurrentCompany.places.map((e) => ({
          value: String(e?.id),
          label: e?.name,
        })),
      ]
      setPlaceOptions(options)
    }
  }, [places, placesFromCurrentCompany, userRole])

  useEffect(() => {
    if (!establishment.establishments || establishment.establishments.length === 0) {
      return
    }

    if (selectedEstablishment && selectedEstablishment !== '') {
      const selectedEst = establishment.establishments.find(
        (e) => e.id === Number(selectedEstablishment),
      )

      let establishmentPlaces = selectedEst?.places

      if (
        establishmentPlaces &&
        Array.isArray(establishmentPlaces) &&
        establishmentPlaces.length > 0
      ) {
        const filteredOptions = [
          { value: 'Все', label: 'Все' },
          ...establishmentPlaces.map((place) => ({
            value: String(place.id),
            label: place.name,
          })),
        ]
        setFilteredPlaceOptions(filteredOptions)
      } else {
        setFilteredPlaceOptions([{ value: 'Все', label: 'Все' }])
      }
    } else {
      setFilteredPlaceOptions([])
    }
  }, [selectedEstablishment])

  const onChangeStartDate = (date: Date) => {
    setSelectedStartDate(date)
    const newDateStr = format(date, 'dd.MM.yyyy')
    setStartDateString(newDateStr)
    setRangeStartISO(convertToISO(newDateStr))
    setOpenStartDate(false)
  }

  const openStartDateDropDown = (e: any) => {
    e.stopPropagation()
    setOpenStartDate(!openStartDate)
  }
  const openFinishDateDropDown = (e: any) => {
    e.stopPropagation()
    setOpenFinishDate(!openFinishDate)
  }
  const onChangeFinishDate = (date: Date) => {
    setSelectedFinishDate(date)
    const newDateStr = format(date, 'dd.MM.yyyy')
    setFinishDateString(newDateStr)
    setRangeEndISO(convertToISO(newDateStr))
    setOpenFinishDate(false)
  }

  const fetchClaims = async (
    page: number,
    segment: string,
    startDate?: string,
    endDate?: string,
  ) => {
    try {
      await dispatch(getMe({ token }))
      await dispatch(
        getCurrentCompany({ token, companyId: String(user?.employee?.company?.id) || undefined }),
      )
      await dispatch(getClients({ token }))
      if (user && user?.employee?.company && userRole != 'superAdmin') {
        dispatch(
          getStaff({
            token,
            companyId: String(user?.employee?.company?.id) || '0',
            itemsPerPage: 10000,
            page: 1,
          }),
        )
        dispatch(getEstablishmentFromCompany({ itemsPerPage: 1000, page: 1, token }))
        dispatch(
          getPlacesFromCompany({
            companyId: String(user?.employee?.company?.id),
            itemsPerPage: 1000,
            page: 1,
            token,
          }),
        )
      }
      if (userRole == 'superAdmin') {
        dispatch(getEstablishments({ token, itemsPerPage: 10000, page: 1 }))
        dispatch(getStaff({ token, itemsPerPage: 1008, page: 1, companyId: '0' }))
        dispatch(getPlaces({ itemsPerPage: 10000, page: 1, token }))
      }
      await dispatch(
        getPagedClaims({
          token,
          page,
          segment,
          limit: 10000,
          yearsAndMonth: undefined,
          search: undefined,
          companyId: user?.employee?.company?.id || null,
          place: selectedPlace ? String(selectedPlace) : undefined,
          establishmentId: Number(selectedEstablishment) || undefined,
          categoryNames: undefined,
          userId: String(selectedCreator) || undefined,
          clientId: Number(selectedClient) || undefined,
          dateRange: {
            start: startDate,
            end: endDate,
          },
        }),
      )
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchClaims(1, '', rangeStartISO ?? '', rangeEndISO ?? '')
  }, [
    rangeStartISO,
    rangeEndISO,
    token,
    dispatch,
    selectedCreator,
    selectedEstablishment,
    selectedPlace,
    selectedClient,
  ])

  useEffect(() => {
    if (pagedClaims && Array.isArray(pagedClaims[0])) {
      setData(pagedClaims[0])
    }
  }, [pagedClaims])

  useEffect(() => {
    if (data && data.length > 0) {
      setFilteredClaims(data)

      const allPayments = collectPaidValues(data)
      setTotalPaid(findTotal(allPayments))
      const allPrices = collectPriceValues(data)

      setTotalPrices(findTotal(allPrices))
      setPeopleCount(findTotal(extractPeopleCounts(data)))
      setInProgressRequests(data.filter((req) => req.status === 'inProgress').length)
      setRejectedRequests(data.filter((req) => req.status === 'rejected').length)
      setcanceledRequests(data.filter((req) => req.status === 'canceled').length)
      setAccepted(data.filter((req) => req.status === 'accepted').length)
      setconfirmed(data.filter((req) => req.status === 'confirmed').length)
      setInAnticipation(data.filter((req) => req.status === 'inAnticipation').length)
      setPaidClaims(data.filter((req) => String(req?.paid) > '0').length)
      setUnpaid(data.filter((req) => String(req?.paid) == '0').length)
    }
    if (data.length == 0) {
      setInProgressRequests(0)
      setRejectedRequests(0)
      setcanceledRequests(0)
      setAccepted(0)
      setconfirmed(0)
      setInAnticipation(0)
      setTotalPaid(0)
      setTotalPrices(0)
      setPeopleCount(0)
      setUnpaid(0)
      setPaidClaims(0)
    }
  }, [data])

  const chartData = [
    { label: 'Подтверждена', value: confirmed, color: '#6A8EFF' },
    { label: 'В работе', value: inProgressRequests, color: '#FFA534' },
    { label: 'Завершена', value: accepted, color: '#32C450' },
    { label: 'Предварительная бронь', value: inAnticipation, color: '#CFCBCB' },
    { label: 'Отменена', value: rejectedRequests, color: '#FF2D2D' },
    { label: 'Отклонена', value: canceledRequests, color: 'black' },
    data.length == 0
      ? { label: 'Нет заявок', value: 1, color: 'gray' }
      : { label: '', value: null, color: '' },
  ]

  return (
    <div className={styles.statsPageContainer}>
      <Navbar />
      <CustomModal visible={openReportsFilter} setVisible={setOpenReportsFilters}>
        <FilterModalModalReports
          setEstablishment={(selectedOption) => {
            if (!selectedOption || selectedOption === 'Все') {
              setSelectedEstablishment('')
            } else {
              setSelectedEstablishment(String(selectedOption))
            }
          }}
          establishmentOptions={establishmentOptions}
          creatorOptions={creatorOptions}
          setCreator={(selectedOption: any) => {
            if (!selectedOption || selectedOption === 'Все') {
              setSelectedCreater('')
            } else {
              setSelectedCreater(String(selectedOption))
            }
          }}
          placeOptions={placeOptions}
          filteredPlaceOptions={filteredPlaceOptions}
          selectedEstablishment={selectedEstablishment}
          setSelectedPlaces={(selectedOption: any) => {
            if (!selectedOption || selectedOption === 'Все') {
              setSelectedPlace('')
            } else {
              setSelectedPlace(String(selectedOption))
            }
          }}
          clientsOptions={clientsOptions}
          setSelectedClients={(selectedOption: any) => {
            if (!selectedOption || selectedOption === 'Все') {
              setSelectedClient('')
            } else {
              setSelectedClient(String(selectedOption))
            }
          }}
          dateBlock={
            <div className={styles.mobileDateContainer}>
              <h3> Период</h3>
              <div className={styles.mobileDateContent}>
                <div className={styles.dateLeftBlock}>
                  <div className={styles.dateBlockTextes}>
                    <h4 className={styles.subtitleMobile}> от</h4>
                    <div className={styles.dateContainer} onClick={(e) => openStartDateDropDown(e)}>
                      <img className={styles.dateIcon} src={CalendarIcon} alt='calendarIcon' />
                      <div className={styles.dateValue}>{startDateString || ' '}</div>
                    </div>
                  </div>
                  <DropDown className={styles.dropDownStart} open={openStartDate}>
                    <Calendar
                      selectedDate={selectedStartDate}
                      selectDate={(date) => onChangeStartDate(date)}
                    />
                  </DropDown>
                </div>
                <div className={styles.dateRightBlock}>
                  <div className={styles.dateBlockTextes}>
                    <h4 className={styles.subtitleMobile}>до</h4>
                    <div
                      className={styles.dateContainer}
                      onClick={(e) => openFinishDateDropDown(e)}
                    >
                      <img className={styles.dateIcon} src={CalendarIcon} alt='calendarIcon' />
                      <div className={styles.dateValue}>{finishDateString || ''}</div>
                    </div>
                  </div>
                  <DropDown className={styles.dropDownEnd} open={openFinishDate}>
                    <Calendar
                      selectedDate={selectedFinishDate}
                      selectDate={(date) => onChangeFinishDate(date)}
                    />
                  </DropDown>
                </div>
              </div>
            </div>
          }
          onClickHandler={() => setOpenReportsFilters(false)}
        />
      </CustomModal>
      <div className={styles.statsPage}>
        <div className={styles.titleBlock}>
          Отчеты
          {isMobile && (
            <div className={styles.mobileButtons}>
              <CustomButton
                title=''
                iconSrc={iconFiltersMobile}
                className={styles.filtersBtn}
                onClick={() => setOpenReportsFilters(true)}
              />
              {data.length >= 1 && (
                <DownloadSmet
                  selectedEstablismentForSmet={selectedEstablismentForSmet}
                  data={data}
                />
              )}
            </div>
          )}
        </div>
        {!isMobile && (
          <div className={styles.firstFiltersBlock}>
            <AnimatePresence>
              <motion.div
                className={styles.rightFilterBlock}
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3 }}
              >
                <div className={styles.rightFilterBlock}>
                  <div className={styles.filtersBlockWrapper}>
                    <div className={styles.managerFilterBlock}>
                      <Select
                        className={styles.selectInput}
                        options={creatorOptions}
                        placeholder='Выберите менеджера'
                        onChange={(selectedOption) => {
                          if (!selectedOption || selectedOption.value === 'Все') {
                            setSelectedCreater('')
                          } else {
                            setSelectedCreater(String(selectedOption.value))
                          }
                        }}
                        classNamePrefix='custom-select'
                        menuPlacement='bottom'
                        menuPosition='absolute'
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            border: 'none',
                            boxShadow: 'none',
                            minHeight: 'auto',
                            backgroundColor: 'transparent',
                          }),
                          menu: (provided) => ({
                            ...provided,
                            right: 0,
                            overflow: 'auto',
                          }),
                          menuList: (provided) => ({
                            ...provided,
                            height: '100%',

                            overflowY: 'auto',
                          }),
                          input: (provided) => ({
                            ...provided,
                            margin: 0,
                            padding: 0,
                          }),
                          valueContainer: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          clearIndicator: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          indicatorSeparator: () => ({
                            display: 'none',
                          }),
                        }}
                      />
                    </div>

                    <div className={styles.placeFilterBlock}>
                      <Select
                        className={styles.selectInput}
                        options={establishmentOptions}
                        placeholder='Выберите площадку'
                        onChange={(selectedOption) => {
                          if (!selectedOption || selectedOption.value === 'Все') {
                            setSelectedEstablishment('')
                            setSelectedPlace('')
                          } else {
                            setSelectedPlace('')
                            setSelectedEstablishment(String(selectedOption.value))
                          }
                        }}
                        classNamePrefix='custom-select'
                        menuPlacement='bottom'
                        menuPosition='absolute'
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            border: 'none',
                            boxShadow: 'none',
                            minHeight: 'auto',
                            backgroundColor: 'transparent',
                          }),
                          menu: (provided) => ({
                            ...provided,
                            right: 0,
                            overflow: 'auto',
                          }),
                          menuList: (provided) => ({
                            ...provided,
                            height: '100%',

                            overflowY: 'auto',
                          }),
                          input: (provided) => ({
                            ...provided,
                            margin: 0,
                            padding: 0,
                          }),
                          valueContainer: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          clearIndicator: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          indicatorSeparator: () => ({
                            display: 'none',
                          }),
                        }}
                      />
                    </div>

                    <div className={styles.placeFilterBlock}>
                      <Select
                        className={styles.selectInput}
                        options={filteredPlaceOptions}
                        placeholder={'Выберите зал'}
                        value={
                          selectedPlace && filteredPlaceOptions.length > 0
                            ? {
                                value: selectedPlace,
                                label:
                                  filteredPlaceOptions.find((opt) => opt.value === selectedPlace)
                                    ?.label || '',
                              }
                            : null
                        }
                        isDisabled={!selectedEstablishment}
                        onChange={(selectedOption) => {
                          if (!selectedOption || selectedOption.value === 'Все') {
                            setSelectedPlace('')
                          } else {
                            setSelectedPlace(String(selectedOption.value))
                          }
                        }}
                        classNamePrefix='custom-select'
                        menuPlacement='bottom'
                        menuPosition='absolute'
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: 'none',
                            boxShadow: 'none',
                            minHeight: 'auto',
                            backgroundColor: state.isDisabled ? '#f5f5f5' : 'transparent',
                            opacity: state.isDisabled ? 0.6 : 1,
                            cursor: state.isDisabled ? 'not-allowed' : 'default',
                          }),
                          menu: (provided) => ({
                            ...provided,
                            right: 0,
                            overflow: 'auto',
                          }),
                          menuList: (provided) => ({
                            ...provided,
                            height: '100%',

                            overflowY: 'auto',
                          }),
                          input: (provided) => ({
                            ...provided,
                            margin: 0,
                            padding: 0,
                          }),
                          valueContainer: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          clearIndicator: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          indicatorSeparator: () => ({
                            display: 'none',
                          }),
                        }}
                      />
                    </div>

                    <div className={styles.placeFilterBlock}>
                      <Select
                        options={clientsOptions}
                        placeholder='Выберите клиента'
                        onChange={(selectedOption) => {
                          if (!selectedOption || selectedOption.value === 'Все') {
                            setSelectedClient('')
                          } else {
                            setSelectedClient(String(selectedOption.value))
                          }
                        }}
                        classNamePrefix='custom-select'
                        menuPlacement='bottom'
                        menuPosition='absolute'
                        className={styles.selectInput}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            border: 'none',
                            boxShadow: 'none',
                            minHeight: 'auto',
                            backgroundColor: 'transparent',
                          }),
                          menu: (provided) => ({
                            ...provided,
                            right: 0,
                            overflow: 'auto',
                          }),
                          menuList: (provided) => ({
                            ...provided,
                            height: '100%',

                            overflowY: 'auto',
                          }),
                          input: (provided) => ({
                            ...provided,
                            margin: 0,
                            padding: 0,
                          }),
                          valueContainer: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          clearIndicator: (provided) => ({
                            ...provided,
                            padding: 0,
                          }),
                          indicatorSeparator: () => ({
                            display: 'none',
                          }),
                        }}
                      />
                    </div>
                    <div className={styles.dateLeftBlock}>
                      <div className={styles.dateBlockTextes}>
                        <h4 className={styles.subtitle}>Период: от</h4>
                        <div
                          className={styles.dateContainer}
                          onClick={(e) => openStartDateDropDown(e)}
                        >
                          <img className={styles.dateIcon} src={CalendarIcon} alt='calendarIcon' />
                          <div className={styles.dateValue}>{startDateString || ' '}</div>
                        </div>
                      </div>
                      <DropDown className={styles.dropDown} open={openStartDate}>
                        <Calendar
                          selectedDate={selectedStartDate}
                          selectDate={(date) => onChangeStartDate(date)}
                          disableDayRestrictions={true}
                        />
                      </DropDown>
                    </div>
                    <div className={styles.dateRightBlock}>
                      <div className={styles.dateBlockTextes}>
                        <h4 className={styles.subtitle}>до</h4>
                        <div
                          className={styles.dateContainer}
                          onClick={(e) => openFinishDateDropDown(e)}
                        >
                          <img className={styles.dateIcon} src={CalendarIcon} alt='calendarIcon' />
                          <div className={styles.dateValue}>{finishDateString || ''}</div>
                        </div>
                      </div>
                      <DropDown className={styles.dropDown} open={openFinishDate}>
                        <Calendar
                          selectedDate={selectedFinishDate}
                          selectDate={(date) => onChangeFinishDate(date)}
                          disableDayRestrictions={true}
                        />
                      </DropDown>
                    </div>
                  </div>
                  {data.length >= 1 && (
                    <DownloadSmet
                      selectedEstablismentForSmet={selectedEstablismentForSmet}
                      data={data}
                    />
                  )}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        )}

        {isMobile ? (
          <div className={styles.moneyBlockMobile}>
            <div style={{ alignItems: 'center', width: '100%' }} className={styles.numbersBlock}>
              <h3 style={{ display: 'flex', gap: '5px' }}>
                {totalPrices}
                <span> руб</span>
              </h3>
              <p>Общая сумма выручки</p>
            </div>
            <div className={styles.numbersSecondBlock}>
              <div className={styles.numbersBlock}>
                <h3>
                  {totalPaid + ' '}
                  <span> руб</span>
                </h3>
                <p>Полученная сумма оплат</p>
              </div>
              <div className={styles.numbersBlock}>
                <h3>
                  {willBePaid}
                  <span> руб</span>
                </h3>
                <p>Предстоящие оплаты</p>
              </div>
              <div className={styles.diagramBlockLeftSide}>
                <div style={{ width: '100%' }} className={styles.numbersBlock}>
                  <h3>{data.length || 0}</h3>
                  <p>Количество клиентов</p>
                </div>
              </div>
              <div className={styles.numbersBlock}>
                <h3>{peopleCount}</h3>
                <p>Количество гостей</p>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.moneyBlock}>
            <div style={{ paddingLeft: '32px' }} className={styles.numbersBlock}>
              <h3 style={{ display: 'flex', gap: '5px' }}>
                {totalPrices}
                <span> руб</span>
              </h3>
              <p>Общая сумма выручки</p>
            </div>
            <div className={styles.numbersBlock}>
              <h3>
                {totalPaid + ' '}
                <span> руб</span>
              </h3>
              <p>Полученная сумма оплат</p>
            </div>
            <div className={styles.numbersBlock}>
              <h3>
                {willBePaid}
                <span> руб</span>
              </h3>
              <p>Предстоящие оплаты</p>
            </div>
            <div className={styles.diagramBlockLeftSide}>
              <div className={styles.numbersBlock}>
                <h3>{data.length || 0}</h3>
                <p>Количество клиентов</p>
              </div>
            </div>
            <div className={styles.numbersBlock}>
              <h3>{peopleCount}</h3>
              <p>Количество гостей</p>
            </div>
          </div>
        )}

        <div className={styles.diagramBlock}>
          <div className={styles.diagramBlockRightSide}>
            <Diagramma
              chartData={chartData}
              total={data.length}
              paid={paidClaims}
              unpaid={unpaid}
            />
          </div>
        </div>
        <div className={styles.showButtons}>
          <div className={styles.statsTitle}>Статистика</div>
          <div className={styles.selectTableBlock}>
            <button onClick={() => setShow(0)} className={show === 0 ? styles.activeButton : ''}>
              По сегменту
            </button>
            <button onClick={() => setShow(1)} className={show === 1 ? styles.activeButton : ''}>
              По выручке
            </button>
            <button onClick={() => setShow(2)} className={show === 2 ? styles.activeButton : ''}>
              По доп. продажам
            </button>
            <button onClick={() => setShow(3)} className={show === 3 ? styles.activeButton : ''}>
              По кол-ву мероприятий
            </button>
          </div>
        </div>

        <div>
          <StatsPageTableComponent
            toShow={show}
            selectedCreator={selectedCreator}
            selectedEstablishment={selectedEstablishment}
            selectedPlace={selectedPlace}
            selectedClient={selectedClient}
          />
        </div>
      </div>
    </div>
  )
}

export default StatsPage
